module.exports = __webpack_public_path__ + "img/cherry_tree.be5030ca.webp";